"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumTextCodec = void 0;
class AltiumTextCodec {
    decode(raw) {
        let text = '';
        const transforms = [];
        let index = 0;
        while (index < raw.length) {
            const characters = [];
            let end = index;
            let hasTrailingTerminator = false;
            if (raw[index] === '\\') {
                while (end + 1 < raw.length && raw[end] === '\\' && raw[end + 1] !== '\\') {
                    characters.push(raw[end + 1]);
                    end += 2;
                }
                if (end < raw.length && raw[end] === '\\' && end + 1 === raw.length) {
                    end++;
                    hasTrailingTerminator = true;
                }
            }
            else if (raw[index] !== ':' && index + 1 < raw.length && raw[index + 1] === '\\') {
                characters.push(raw[index]);
                end++;
                while (end + 1 < raw.length && raw[end] === '\\' && raw[end + 1] !== '\\') {
                    characters.push(raw[end + 1]);
                    end += 2;
                }
                if (end < raw.length && raw[end] === '\\' && end + 1 === raw.length) {
                    end++;
                    hasTrailingTerminator = true;
                }
            }
            if (characters.length > 0 && (characters.length > 1 || hasTrailingTerminator)) {
                const from = text.length;
                text += characters.join('');
                transforms.push({ type: 'bar', from, to: text.length });
                index = end;
                continue;
            }
            text += raw[index];
            index++;
        }
        return { text, transforms };
    }
}
exports.AltiumTextCodec = AltiumTextCodec;
//# sourceMappingURL=AltiumTextCodec.js.map